import { type Context, createContext } from 'react';

/** @internal */
type AccordionSectionContextProps = {
  labelId: string;
  sectionAriaLabel: string | undefined;
  contentId: string;
  isExpanded: boolean;
  keepMounted: boolean;
  size: 'default' | 'condensed';
};

/** @internal */
export const AccordionSectionContext: Context<AccordionSectionContextProps> =
  createContext<AccordionSectionContextProps>({
    labelId: '',
    sectionAriaLabel: undefined,
    contentId: '',
    isExpanded: false,
    keepMounted: false,
    size: 'default',
  });
